/**
 * Web ClockAdapter — wraps `Date.now()` so reducers and orchestrators stay
 * deterministic under test (see @shopista/shared/stores ClockAdapter).
 */

import type { ClockAdapter } from '@shopista/shared/stores';

export function createWebClockAdapter(): ClockAdapter {
  return {
    now(): number {
      return Date.now();
    },
    nowIso(): string {
      return new Date().toISOString();
    },
  };
}
